import {withKnownRoute} from '../../lib/routes';
import {MapsPage} from './maps-page';

export default withKnownRoute(MapsPage);
